import { Button, Card, Col, Row } from "react-bootstrap";
import { Translate } from "../../Enums/Tranlate";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Static from "./Static";
import LandingPageService from "../../../services/LandingPageService";
import BaseService from "../../../services/BaseService";
import { toast } from "react-toastify";
import "./style.scss";

const HomePage = () => {
	const [clientsData, setClientsData] = useState([]);
	const [banner, setBanner] = useState({
		src: "",
		loading: false,
		title_en: "",
		title_ar: "",
	});
	const lang = useSelector((state) => state.auth?.lang);
	const [loadingClients, setLoadingClients] = useState(false);
	const [newClients, setNewClients] = useState([]);
	const [shouldClientUpdate, setShouldClientUpdate] = useState(false);
	const landingPageService = new LandingPageService();

	useEffect(() => {
		landingPageService.getList("banner").then((res) => {
			if (res?.status === 200) {
				let response = res?.data?.data;
				if (!!response?.length) {
					setBanner({
						src: response[0]?.image,
						loading: false,
						title_en: response[0]?.title_en || "",
						title_ar: response[0]?.title_ar || "",
					});
				}
			}
		});
	}, []);

	useEffect(() => {
		landingPageService.getList("client").then((res) => {
			if (res?.status === 200) {
				let response = res?.data?.data;
				if (!!response?.length) {
					setClientsData(response);
				}
			}
		});
	}, [shouldClientUpdate]);

	const fileHandler = (e, type) => {
		if (e.target.files?.length === 0) {
			return;
		}
		if (type === "banner") {
			setBanner((prev) => ({ ...prev, loading: true }));
		}
		if (type === "clients") {
			setLoadingClients(true);
		}
		let files = e.target.files;
		const filesData = Object.values(files);

		if (filesData.length) {
			new BaseService().postUpload(filesData[0]).then((res) => {
				if (res.status) {
					if (type === "banner") {
						setBanner((prev) => ({
							...prev,
							src: res?.data?.url,
							loading: false,
						}));
					}
					if (type === "clients") {
						setNewClients((prev) => [...prev, { image: res?.data.url }]);
						// setClientsData((prev) => [...prev, { image: res?.data?.url }]);
						setLoadingClients(false);
					}
				}
			});
		}
	};

	const submitClients = () => {
		let data = {
			images: newClients?.map((res) => res?.image),
		};
		setLoadingClients(true);
		landingPageService.create("client", data).then((res) => {
			if (res?.status === 201) {
				toast.success(`${Translate[lang].updated_successfully}`);
				setNewClients([]);
				setShouldClientUpdate((prev) => !prev);
			}
			setLoadingClients(false);
		});
	};

	const submitBanner = () => {
		let data = {
			image: banner?.src,
		};
		if (!!banner?.title_en) data["title_en"] = banner?.title_en;
		if (!!banner?.title_ar) data["title_ar"] = banner?.title_ar;
		let bannerData = {
			banners: [data],
		};

		landingPageService.create("banner", bannerData).then((res) => {
			if (res?.status) {
				toast.success("Banner Added Successfully");
			}
		});
	};

	const removeClient = (client) => {
		landingPageService.remove("client", client?.id).then((res) => {
			if (res?.status === 200) {
				toast.success(
					`${Translate[lang].delete} ${Translate[lang].successfully}`
				);
				setClientsData((prev) =>
					prev.filter((item) => item?.id !== client?.id)
				);
			}
		});
	};

	return (
		<>
			<Card className="mb-5">
				<Card.Body>
					<AvForm onValidSubmit={submitBanner}>
						<Row>
							<Col md={12} className="text-black fs-24 fw-bold mb-3">
								{Translate[lang].banner}
							</Col>
							<Col md={6} className="fw-bold">
								<AvField
									label={Translate[lang].english_title}
									placeholder={Translate[lang].english_title}
									name="english_title"
									required
									value={banner?.title_en}
									onChange={(e) =>
										setBanner((prev) => ({
											...prev,
											title_en: e.target?.value,
										}))
									}
								/>
							</Col>
							<Col md={6} className="fw-bold">
								<AvField
									label={Translate[lang].arabic_title}
									placeholder={Translate[lang].arabic_title}
									name="title_ar"
									required
									value={banner?.title_ar}
									onChange={(e) =>
										setBanner((prev) => ({
											...prev,
											title_ar: e.target?.value,
										}))
									}
								/>
							</Col>

							<Col md={6}>
								<label className="text-label mb-0">
									{Translate[lang].image}
								</label>
								<div className="upload">
									<input
										type="file"
										name="image"
										id="image"
										accept="image/*"
										multiple
										onChange={(e) => fileHandler(e, "banner")}
									/>
									<p>{Translate[lang].upload_image} / 1440*650</p>
									{!banner?.src ? (
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M12 15V3.62"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M15.35 5.85L12 2.5L8.65002 5.85"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									) : (
										<svg
											width="24"
											height="24"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
												fill="#21AA37"
											/>
										</svg>
									)}
								</div>
								{!!banner?.src && (
									<div className="mt-3">
										<img
											src={banner.src}
											alt="icon"
											width={350}
											height={200}
											style={{ borderRadius: "30px" }}
										/>
									</div>
								)}
							</Col>
							<Col md={12} className="mt-3">
								<Button
									type="submit"
									className="w-50 fs-14"
									disabled={banner?.loading}
									variant="primary">
									{Translate[lang].submit}
								</Button>
							</Col>
						</Row>
					</AvForm>
				</Card.Body>
			</Card>
			<Card className="mb-5">
				<Card.Body>
					<Row>
						<Col
							md={12}
							style={{ fontSize: "24px" }}
							className="text-black fw-bold mb-3">
							{Translate[lang].clients}
						</Col>
						<Col md={12}>
							<label className="text-label mb-0">
								{Translate[lang].images}
							</label>
							<div className="upload w-50">
								<input
									type="file"
									name="image"
									id="image"
									accept="image/*"
									multiple
									onChange={(e) => fileHandler(e, "clients")}
								/>
								<p>
									{Translate[lang].upload_images}{" "}
									<span style={{ fontSize: "12px" }}>( Max Height 100px )</span>
								</p>
								{!clientsData?.length || !newClients?.length ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{(!!clientsData?.length || !!newClients?.length) && (
								<div className="row">
									{clientsData?.map((res, index) => (
										<div className="mt-3 col-md-2 col-3" key={index}>
											<i
												className="las la-trash text-danger fs-20 cursor-pointer"
												onClick={() => {
													removeClient(res);
												}}
											/>
											<img
												src={res?.image}
												alt={index}
												key={index}
												style={{ borderRadius: "8px" }}
												className="w-100 h-100"
											/>
										</div>
									))}
									{newClients?.map((res, index) => (
										<div className="mt-3 col-md-2 col-3">
											<i
												className="las la-trash text-danger fs-20 cursor-pointer"
												onClick={() =>
													setNewClients((prev) =>
														prev.filter((_, ind) => ind !== index)
													)
												}
											/>
											<img
												src={res?.image}
												alt={index}
												key={index}
												style={{ borderRadius: "8px" }}
												className="w-100 h-100"
											/>
										</div>
									))}
								</div>
							)}
						</Col>
						<Col md={12} className="mt-3">
							<Button
								type="button"
								className="w-50 fs-14"
								disabled={loadingClients}
								onClick={submitClients}
								variant="primary">
								{Translate[lang].submit}
							</Button>
						</Col>
					</Row>
				</Card.Body>
			</Card>

			<Card className="mb-5">
				<Card.Body>
					<Static />
				</Card.Body>
			</Card>
		</>
	);
};
export default HomePage;
